import React from "react";
import { connect } from 'react-redux';
import SimpleSlider from './simpleSlider';
import CategorySlider from './categorieSlider';
import { getPartnerSearch } from '../../../action/partner/getPartnerSearch';
import HomeBanner from "./homeBannerOne";
import HomeBannerInactive from "./HomeBannerInactive";
import Loader from "../../loader/loader";
import { Link } from 'react-router-dom';
import { getContractSummary } from '../../../action/contract/getContractSummary';
import { analyticsClickEvent } from "../../../action/firebaseAnalytics/firebaseAnalytics";
import {getApplicationStatus} from "../../../action/application/getApplicationStatus"
import { GTMUserIdAndLoginState } from "../../../utils/GtmDatalayer";
import { PropTypes } from 'prop-types';
import withRouter from "../../../withRouter";
import { getAvatar } from '../../../action/avatar/getAvatar';
import {getUserBlockStatus} from '../../../action/auth/login'
import { getSessionIdFromStorage, fetchBannerConfiguration, generateUuid, getUserContext } from "../../../utils/helpers/storageUtils";
export class Home extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            userName: '',
            messageVisibility: true,
            profilePicture: props.profilePicture,
            FeaturedPartnerSliderData: '',
            AllPartnerSliderData: '',
            displayClass: 'none',
            setUniqueIndustries: '',
            sticky: 'fadeInDown animated fadeOutUp',
            isLoading: false,
            renderChild: '',
            contractSummary: props.contractSummary,
            applicationImage: 'images/home-active-contract-bg.png',
            applicationStatus:''


        };
        this.handleScroll = this.handleScroll.bind(this);
        this.toggleMessage = this.toggleMessage.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.profilePicture !== nextProps.profilePicture) {
            return {
                profilePicture: nextProps.profilePicture
            };
        }
        if (prevState.contractSummary !== nextProps.contractSummary) {
            return {
                contractSummary: nextProps.contractSummary
            };
        }
        return null;
    }


    handleScroll = (e) => {

        if (window.scrollY  > 249) {
            this.setState({ sticky: 'fadeInDown animated' });
        } else {
            this.setState({ sticky: 'fadeInDown animated fadeOutUp' });
        }

    }

    async componentDidMount() {
        // analyticsScreenViewEvent()
        window.dataLayer = window.dataLayer || {}; 
        GTMUserIdAndLoginState();
        this.props.fetchBannerConfiguration();
        generateUuid();
        let hasSession = (localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') && localStorage.getItem('sessionId') !== null && sessionStorage.getItem('isDetailsSet') != 'true';
        if(hasSession){
        this.setUserDetailsInSession();
        this.setBlockedUserInsessionStorage();
    }

        await this.initialLoad('comp');
        window.addEventListener('scroll', this.handleScroll);
        window.onpopstate = () => {
            const { location, history } = this.props;
            if (location.pathname === '/welcome') {
                history.go(1);
            }
        };

        
        let appImg = sessionStorage.getItem("applicationImage");
        if (appImg === null) {
            let appliImg = this.props.location.state;
            sessionStorage.setItem('applicationImage', appliImg.applicationImage);
            this.setState({ applicationImage: appliImg.applicationImage });
        } else {
            this.setState({ applicationImage: appImg });
        }

     if ((localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') && localStorage.getItem('sessionId') !== null) {
        const result=await getApplicationStatus(getUserContext());
        if(result.data.data){
            this.setState({applicationStatus:result.data.data.current_application_status})
        }
     }
     
}

    setUserDetailsInSession = async () => {

        const UserDetailsResult = await getAvatar(getUserContext());
       
            if(UserDetailsResult?.data?.statusCode===200){
            let mob = UserDetailsResult.data.data.mobile_number;
            let isEmailConsentChecked = UserDetailsResult.data.data.email_marketing_consent;
            let isSMSConsentChecked = UserDetailsResult.data.data.sms_marketing_consent;
            let isMobileAppConsentChecked = UserDetailsResult.data.data.mobile_app_marketing_consent;
            let username = UserDetailsResult.data.data.username;
            let userID = UserDetailsResult.data.data.id;
            if (UserDetailsResult.data.data.image_path) {
                let userPicture = 'data:image/jpeg;base64,' + UserDetailsResult.data.data.image_path
                this.props.setProfilePic(userPicture);
            }
            else {
                let userPicture = sessionStorage.getItem("profilePicture");
                if (userPicture != null) {
                    this.props.setProfilePic(userPicture);
                } else if (localStorage.getItem('fromWhere') === 'skip') {
                    this.props.setProfilePic('images/profile-avatar.png');
                }
            }
            sessionStorage.setItem('mobileNumber', mob);
            sessionStorage.setItem('UserName', username);
            this.props.setUserName(username);
            sessionStorage.setItem('emailConsent', isEmailConsentChecked);
            sessionStorage.setItem('smsConsent', isSMSConsentChecked);
            sessionStorage.setItem('mobileConsent', isMobileAppConsentChecked);
            sessionStorage.setItem('userID', userID);
            sessionStorage.setItem('isDetailsSet', 'true');

          this.setState({
            isEmailConsentChecked: UserDetailsResult.data.data.email_marketing_consent, 
            isSMSConsentChecked: UserDetailsResult.data.data.sms_marketing_consent,
            isMobileAppConsentChecked: UserDetailsResult.data.data.mobile_app_marketing_consent,
            username: UserDetailsResult.data.data.username
          }, () => {
            
          });

      
    }

    }

    setBlockedUserInsessionStorage = async() => {
            if(localStorage.getItem('fromWhere')!='skip'){
                let sessionId = getSessionIdFromStorage();
                if(sessionId) {
                    const getBlockedUser=await getUserBlockStatus();
                    if (getBlockedUser && Array.isArray(getBlockedUser.data.data) && getBlockedUser.data.data.length !== 0) {
                        sessionStorage.setItem('blockedUsers', getBlockedUser.data.data.blockstatus);
                    }
                }
            }
    }

    checkContractResponseFromApi = (contractSummaryResult) => {
        let summary = '';
        if (contractSummaryResult !== undefined) {
            if (contractSummaryResult.status === 200) {
                for (const [key, value] of Object.entries(contractSummaryResult.data)) {
                    if (key === "data") {
                        summary = value;
                    }
                }
                this.props.getContractSummaryDetails(summary);

            }
        }
    }

    checkContractDetailsToSetProps = async (contractData,favcallData) => {
        if (!contractData) {
            if (favcallData != 'fav') {
                this.setState({ isLoading: true });
            }
            if ((localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') && localStorage.getItem('sessionId') !== null) {
                const contractSummaryResult = await getContractSummary(getUserContext());
                this.checkContractResponseFromApi(contractSummaryResult);
            }
        }
    }

    initialLoad = async (favcallData) => {
        let contractData = this.props.location?.state == null  ? this.props.contractSummary: this.props.location?.state?.contractSummary;
        await this.checkContractDetailsToSetProps(contractData,favcallData);
        if (favcallData != 'fav') {
            this.setState({ isLoading: true });
        }
        const partnerSearch = {
            "Industry": "",
            "Location": "",
            "IsOnline": false,
            "Keywords": "",
            "offers": false,
            ...getUserContext()
        }
        let result = await this.props.getPartnerSearch(partnerSearch);
        result = result.data;
        let FeaturedPartnerData = [];
        let AllPartnerData = [];
        let uniqueIndustries = {};

        await Promise.all(result.data.map( async(response) => {

        const obj={
            partnerId: response.hummuk_account_id,
            partnerName: response.hummuk_account_Name,
            partnerIndustry: response.hummuk_account_Industry,
            partnerLogo: response.hummuk_account_flxLogo__c,
            partnerCoverImage: response.hummuk_account_Cover_Image__c,
            partnerWebSite: response.hummuk_account_Website,
            partnerFavId: response.fav_id
        }
            if(response.hummuk_account_Featured_Partner__c===true){ 
            FeaturedPartnerData.push(obj)
            }
        
            AllPartnerData.push(obj)
            const industry = response.hummuk_account_Industry;
            if(industry){
				uniqueIndustries[industry] = response.hummuk_industry_image;
			}
    
        }));
        let industryArray = Object.keys(uniqueIndustries).map(key => ({name: key,image: uniqueIndustries[key]}));
        industryArray.sort((a,b)=>(a.name > b.name ? 1 : -1));
        this.setState({ setUniqueIndustries: industryArray });
        this.setState({ AllPartnerSliderData: AllPartnerData });
        this.setState({ FeaturedPartnerSliderData: FeaturedPartnerData });
        this.IndustriesBased();
        this.setState({ isLoading: false });

    }




    toggleMessage = () => {

        this.setState(prevState => ({
            messageVisibility: !prevState.messageVisibility
        }));

        if (this.state.messageVisibility) {
            this.setState({ displayClass: 'block' });
        } else {
            this.setState({ displayClass: 'none' });
        }
    };


    IndustriesBased = () => {
        if (this.state.setUniqueIndustries) {
            return this.state.setUniqueIndustries.map((cat_item) => {
                let item = [];
                const industryName=cat_item.name;
                return <section className="featured-partners" key={industryName}>
                    <div className="container">
                        <div className="feature-section">
                            <div className="featured-title-section">
                                {industryName!=null && industryName!=undefined && industryName!='' &&
                                    <h6 className="section-main-title">{industryName.toUpperCase()}</h6>
                                }   
                                {industryName !=null && industryName !=undefined && industryName !='' &&
                                    <p className="section-sub-title">Just some of our amazing {industryName} partners</p>
                                }
                            </div>
                            <div className="featured-partners-list">
                                {
                                    this.state.AllPartnerSliderData.map((src_data) => {
                                        if (src_data.partnerIndustry === industryName) {
                                            item.push(src_data);
                                        }
                                    })
                                }
                                <SimpleSlider items={item} favCall={this.favcall} />
                            </div>
                        </div>
                    </div>
                </section>

            })
        }
    }


    stickyPosition = () => {
        if (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') {
            return {};
        }
        const isActorLogin = !!sessionStorage.getItem('actor')
        return <div className={`lr-item--hero scroll-animation ${this.state.sticky}`}>
             <div className={`hero-left ${isActorLogin ? "hero-navbar" : ""}`}>
                <div className="hero-left-top container custom-container-sec">
                    <div className="col-lg-2 col-md-2 p-0 user-info">
                        <div className="profile-item-sec">
                            <span className="user-image-area sticky-profile-img">
                                {this.state.profilePicture !== '' && this.state.profilePicture !== null &&
                                    <img src={this.state.profilePicture} alt="User avatar" />
                                }
                                {this.state.profilePicture === null &&
                                    <div className="no-profile-image">
                                        {sessionStorage.getItem('UserName') !== '' && sessionStorage.getItem('UserName') !== null &&
                                            <span className="no-profile-image-letter-sticky">{sessionStorage.getItem('UserName').substring(0, 1).toUpperCase()}</span>
                                        }
                                    </div>

                                }
                            </span>
                            <span className="user-name-area">
                                {sessionStorage.getItem('UserName') !== '' && sessionStorage.getItem('UserName') !== null &&
                                    <h6>Hi {sessionStorage.getItem('UserName')}!</h6>
                                }
                                {sessionStorage.getItem('UserName') === null &&
                                    <h6>Hi Sammi!</h6>
                                }
                            </span>
                        </div>
                    </div>
                    <div className="col-lg-10 col-md-10 p-0 user-expense ">

                        <div className="total-to-spend">
                            <h6>Total To Spend</h6>
                            {this.state.contractSummary?.total_amount !== undefined &&
                                <h2>£{this.state.contractSummary.total_amount ? this.state.contractSummary.total_amount : '0.00'}</h2>
                            }
                            {this.state.contractSummary && this.state.contractSummary.total_amount == undefined &&
                                <h2>£{this.state.contractSummary.total_amount == undefined ? '0.00' : this.state.contractSummary.total_amount}</h2>
                            }

                            {this.state.contractSummary == null || this.state.contractSummary == '' &&
                                <h2>£{this.state.contractSummary == '' ? '0.00' : this.state.contractSummary.total_amount}</h2>
                            }
                        </div>
                        <div className="next-payment">

                            <h6>Next Payment</h6>
                            {this.state.contractSummary?.next_payment_amount !== undefined && this.state.contractSummary?.next_payment_amount !== '' && this.state.contractSummary?.next_payment_amount !== 0 &&

                                <h2>£{this.state.contractSummary.next_payment_amount !== undefined ? this.state.contractSummary.next_payment_amount : '0.00'}</h2>
                            }

                            {this.state.contractSummary?.next_payment_amount == '' && this.state.contractSummary?.next_payment_amount == 0 &&
                                <h2>£0.00</h2>
                            }
                            {this.state.contractSummary && this.state.contractSummary.next_payment_date == undefined &&
                                <h2>{this.state.contractSummary == undefined ? this.state.contractSummary.next_payment_date : ''}</h2>
                            }
                            {this.state.contractSummary == null || this.state.contractSummary == '' &&
                                <h2>£{this.state.contractSummary !== '' ? this.state.contractSummary.next_payment_amount : '0.00'}</h2>

                            }
                            {this.state.contractSummary == null || this.state.contractSummary == '' &&

                                <span>{this.state.contractSummary !== '' ? this.state.contractSummary.next_payment_date : ''}</span>
                            }
                            {this.state.contractSummary?.next_payment_date !== undefined &&
                                <span>{this.state.contractSummary !== null ? this.state.contractSummary.next_payment_date : ''}</span>
                            }

                        </div>


                    </div>
                </div>
            </div>
        </div>
    }

    mainTab = () => {
         return  <div className="col-md-5 ml-2 p-0 user-info">

            {this.state.profilePicture !== '' && this.state.profilePicture !== null &&
                <span className="user-image-area">
                    <img src={this.state.profilePicture} alt="User Profile" />
                </span>
            }
            {this.state.profilePicture === null &&
                <div className="no-profile-image-home">
                    {sessionStorage.getItem('UserName') !== '' && sessionStorage.getItem('UserName') !== null &&
                        <span className="no-profile-image-letter-wallet">{sessionStorage.getItem('UserName').substring(0, 1).toUpperCase()}</span>
                    }
                </div>
            }
            <span className="user-name-area">
                {sessionStorage.getItem('UserName') !== '' && sessionStorage.getItem('UserName') !== null &&
                    <h6>Hi {sessionStorage.getItem('UserName')}!</h6>
                }
                {sessionStorage.getItem('UserName') === null &&
                    <h6>Hi!</h6>
                }

            </span>
        </div>
    }

    favcall = () => {
        setTimeout(() => {
            this.initialLoad('fav')
            .catch(error => console.error(error));
            
        }, 100);
    }

    displayUserAmountDetails = () => {
        return (
            <div className="col-md-7 p-0 pr-5 user-expense ">
                <div className="total-to-spend">
                    <h6>Total To Spend</h6>
                    <h2>£{this.state.contractSummary.total_amount ? this.state.contractSummary.total_amount : '0.00'}</h2>
                </div>
                <div className="next-payment">
                    <h6>Next Payment</h6>
                    <h2>£{this.state.contractSummary.next_payment_amount ? this.state.contractSummary.next_payment_amount : '0.00'}</h2>
                    <span>{this.state.contractSummary ? this.state.contractSummary.next_payment_date : ''}</span>
                </div>
            </div>
        );
    }

    analyticsclickEventForWallet = () => {
        analyticsClickEvent('wallet', '');
    }

    analyticsclickEventForViewAllPartners = () => {
        analyticsClickEvent('view_all', '');
    }

    render() {
        return (
            <div className="wrapper home-wrapper" >
                <Loader loaderStatus={this.state.isLoading} />
                {this.state.applicationStatus!="approved" &&
                    <section className="main">
                        <div className="container">
                            <div className="hero-section col-md-12 pt-5 pb-5">
                                <div className="row">
                                    {localStorage.getItem('fromWhere') != 'skip' &&
                                        <div className={`${sessionStorage.getItem('blockedUsers') != 'true' ? 'col-md-5' : 'col-md-12'}  col-sm-12 col-xs-12 lr-item--hero on-scroll-hide"`}>
                                            <div className="hero-left">
                                                <div className="hero-left-top">
                                                     <div className="col-md-5 ml-2 p-0 user-info">

                                                        {this.state.profilePicture !== '' && this.state.profilePicture !== null &&
                                                            <span className="user-image-area">
                                                                <img src={this.state.profilePicture} alt="User Profile" />
                                                            </span>
                                                        }
                                                        {this.state.profilePicture === null &&
                                                            <span className="user-image-area">
                                                                <div className="no-profile-image-home">
                                                                    {sessionStorage.getItem('UserName') !== '' && sessionStorage.getItem('UserName') !== null &&
                                                                        <span className="no-profile-image-letter-wallet">{sessionStorage.getItem('UserName').substring(0, 1).toUpperCase()}</span>
                                                                    }
                                                                </div>
                                                            </span>
                                                        }
                                                        <span className="user-name-area">
                                                            {sessionStorage.getItem('UserName') !== '' && sessionStorage.getItem('UserName') !== null &&
                                                                <h6>Hi {sessionStorage.getItem('UserName')}!</h6>
                                                            }
                                                            {sessionStorage.getItem('UserName') === null &&
                                                                <h6>Hi Sammi!</h6>
                                                            }

                                                        </span>
                                                    </div>
                                                    {this.displayUserAmountDetails()}
                                                </div>
                                                <div className="hero-left-bottom">
                                                    <Link to="/wallet" onClick={this.analyticsclickEventForWallet} >Go To Wallet <img src="images/right-arrow.svg" className="go-wallet" alt="next" /></Link>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {sessionStorage.getItem('blockedUsers') != 'true' &&
                                        <div className={`${localStorage.getItem('fromWhere') != 'skip' ? 'col-md-7' : 'col-md-12'} col-sm-12 col-xs-12 lr-item--hero on-scroll-hide`}>
                                            <HomeBannerInactive applicationImage={this.state.applicationImage} />
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                        { Object.keys(this.stickyPosition()).length ? this.stickyPosition() : ''}
                    </section>
                }
                {this.state.applicationStatus==="approved" &&
                    <section className="main">
                        <div className="container">
                        <div className="hero-section col-md-12 pt-5 pb-5">
                            
                            <div className="row">
                                <div className="hero-section col-md-12 pt-5 pb-5">

                                    <div className="row m-0" >
                                        <div className="col-md-5 col-sm-12 col-xs-12 lr-item--hero on-scroll-hide">
                                            <div className="hero-left">
                                                <div className="hero-left-top">
                                                    {this.mainTab()}
                                                    {this.displayUserAmountDetails()}
                                                </div>
                                                <div className="hero-left-bottom">
                                                    <Link to="/wallet" onClick={this.analyticsclickEventForWallet} >Go To Wallet <img src="images/right-arrow.svg" className="go-wallet" alt="next" /></Link>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-7 col-sm-12 col-xs-12 lr-item--hero on-scroll-hide">
                                            <HomeBanner />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>

                        {this.stickyPosition()}
                    </section>
                }
                <section className="featured-partners">
                    <div className="container">
                        <div className="feature-section">
                            <div className="d-flex">
                                <div className="featured-title-section">
                                    <h6 className="section-main-title">FEATURED PARTNERS</h6>
                                    <p className="section-sub-title">Just some of our amazing retail partners</p>
                                </div>
                                <div className="ml-auto">
                                    <Link to='/shop' className="view-all-btn" onClick={this.analyticsclickEventForViewAllPartners}>View All</Link>
                                </div>
                            </div>
                            <div className="featured-partners-list">
                                {this.state.FeaturedPartnerSliderData &&
                                    <SimpleSlider items={this.state.FeaturedPartnerSliderData}  favCall={this.favcall} />
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <section className="featured-partners">
                    <div className="container">
                        <div className="feature-section">
                            <div className="featured-title-section">
                                <h6 className="section-main-title">STORE CATEGORIES</h6>
                                <p className="section-sub-title">Find all your favourite little and big things, online and instore at all the big brands.</p>
                            </div>
                            <div className="featured-partners-list">
                                {this.state.setUniqueIndustries &&
                                    <CategorySlider items={this.state.setUniqueIndustries}/>
                                }
                            </div>
                        </div>
                    </div>
                </section>
                {this.state.setUniqueIndustries && this.state.AllPartnerSliderData && this.state.setUniqueIndustries &&
                    this.IndustriesBased()
                }
                <div className="chat-box-section">
                    <div className="chat-box">

                        <button type="button" id='chat' onClick={() => { analyticsClickEvent('support_mail', ''); window.open('https://mail.google.com/mail/u/0/?fs=1&to=' + process.env.REACT_APP_HUMM_SUPPORT_EMAIL_ID + '&su=Enquiry&tf=cm') }} className="chat-box-btn"><img src="images/chat-icon.svg" alt="chat-box" /></button>

                    </div>
                </div>

            </div>
        );
    }

}

export const mapStateToProps = (state) => {
    return {

        profilePicture: state.dataStore.profilePicture,
        allpartnerListSearchStore: state.dataStore.allpartnerListSearchStore,
        contractSummary: state.dataStore.contractSummary,
        storePartnerImage: state.dataStore.storePartnerImage,
        isBannerEnable: state.dataStore.isBannerEnable,
        userName:state.dataStore.userName
    };
};



export const mapDispatchToProps = (dispatch) => {
    return {
        getPartnerSearch: (formData) => {
            return dispatch(getPartnerSearch(formData));
        },
        getContractSummaryDetails: (summary) => {
            return dispatch({
                type: 'SET_CONTRACT_SUMMARY',
                value: summary
            });
        },
        storePartnerImagefunction:(formData)=>{
            return dispatch({
                type: 'STOREPARTNERIMAGE',
                value: formData
            });
        },
        setUserName: (value) => {
            return dispatch({
                type: 'SET_USERNAME',
                value: value
            })
        },
        setProfilePic:(userPic)=>{
          return dispatch({
              type: 'SET_PROFILE_PIC',
              value: userPic
          });
        },
        fetchBannerConfiguration: () => {
            return dispatch(fetchBannerConfiguration());
        }
    }
}

Home.propTypes = {
    getPartnerSearch: PropTypes.func,
    profilePicture: PropTypes.string,
    contractSummary: PropTypes.string,
    getContractSummaryDetails: PropTypes.func,
    location: PropTypes.object,
    history: PropTypes.object,
    setProfilePic: PropTypes.func
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))